export const TOOLTIPS = {
  // *************************CONTEST LEVEL TOOLTIPS ***************************
  contestName: (isAssessment) =>
    `Unique name for the ${
      isAssessment ? 'assessment' : 'contest'
    } which will be displayed to all users including the candidates.`,
  contestUri: (isAssessment) =>
    `URL on which the ${
      isAssessment ? 'assessment' : 'contest'
    } will be accessible on the internet.`,
  practiceChallenge: (isAssessment) =>
    `Optional Practice challenge that candidates can take up before the actual ${
      isAssessment ? 'assessment' : 'contest'
    }. Candidates will be able to take this practice challenge to familiarize themselves with the IDE / Notebook environment.`,
  performSystemCheck: (isAssessment) =>
    `The candidates will need to complete some pre-requisite system checks before being allowed to take the ${
      isAssessment ? 'assessment' : 'contest'
    }. These checks include - internet speed test, webcam test (if Requires Webcam Sharing was selected), and screensharing test (if Requires Screensharing was selected).`,
  autoStartRecording:
    'If enabled then recording will start automatically after 10s',
  videoResponseQuestionMandatory:
    'If enabled candidate will not able to skip question',
  videoResponseAnswerTime:
    'Test takers can record up to the set duration. If not specified, the default limit is 10 minutes.',
  videoResponseAllowRetake: 'No of retake allow for candidate',
  webcamSharing:
    'The candidates will need to keep their webcam turned on, if this option is selected.',
  fullScreenMode:
    'The candidates will need to use full-screen mode if this option is selected.',
  screenSharing:
    'The candidates will need to share their screen in full-screen mode, if this option is selected.',
  disableCopyPaste:
    'This will restrict copy/paste from external sources; however, candidates can copy/paste within the test window if this option is selected.',
  dynamicCandidateRegistration:
    'If enabled, anyone with the contest or assessment URL can apply and participate without an invitation. If disabled, only invited candidates can join.',
  disableContextMenu: `Enable this setting to block candidates from using the right-click context menu during the test, ensuring they can't access additional browser options.`,
  disableDualScreenUsage:
    'Enable this setting to block candidates from using the dual screen during the test. Note: By enabling this feature, candidates will only be able to use a Chromium-based browser (e.g., Google Chrome, Microsoft Edge or Opera).',
  isAutomated:
    'Automatically move candidates to the next stage after they complete the current one.',
  registrationUrl:
    'This link provides access to the application form. Share it with candidates so they can apply by entering their form details.',

  // *************************STAGE LEVEL TOOLTIPS**************************
  stageName:
    'Name of the stage which will be displayed to all users including the candidates.',
  duration: 'Assigned duration for the stage in minutes.',
  timeLimitForResponse:
    'Specify the maximum allowed response duration for candidates. Enter a number and select the appropriate time unit from the dropdown (minutes, hours, or days). This controls how long each candidate can take to record their video answer.',
  maxDuration:
    'This value is automatically calculated as the sum of all groups approximate durations, It cannot be edited manually.',
  strictSubmission: `If enabled, the candidate's solution will be automatically submitted when the stage duration ends.`,
  allowedLanguages:
    'Select programming languages that the candidate will be allowed to choose from while attempting a challenge during this stage.',
  weightedScore: 'Weighted score of this challenge within this stage.',
  stageType:
    'Type of the stage - Programming, Application, SQL, Notebook, DBT, etc.',
  technology: 'Select the application technology for this stage.',
  progressionScore:
    'Candidates scoring equal to or above this percentage will proceed to the next stage.',
  sameQuestion:
    'When enabled, all candidates will receive the exact same questions in this stage.',
  shuffleQuestion:
    'When enabled, questions will appear in a random order for each candidate.',
  disableQuestionRevisit:
    'If enabled, candidates will not be able to go back to previous questions or change their answers after moving forward.',
  dynamicMcqStage:
    'Defines how many Easy, Medium, and Hard questions are pulled per selected skill (e.g., Java, JavaScript, C++). Adjust to balance challenge difficulty for participants.',
  // *************************CONTEST LEVEL TOOLTIPS ***************************
  challengeName:
    'Unique name for the challenge, visible to all users including candidates.',
  challengeDescription:
    'Detailed description of the challenge, including the problem statement, requirements, and expected outcomes.',
  suggestedDuration:
    'Recommended time (in minutes) for candidates to complete the challenge.',
  tags: 'Keywords or labels to categorize the challenge, making it easier to filter and search.',
  penalty:
    'Enter the penalty percentage to be deducted for each incorrect answer. (e.g., enter 10 for a 10% deduction).',
  evaluationType: 'Defines how candidate submissions will be evaluated.',
  database:
    'Specifies the database that candidates will interact with during the challenge.',
  joinInterview: 'Join Interview',
  candidateListForInterview: 'Candidate List for Interview',
  joinPlacementTalk: 'Join Placement Talk',
  superviseStage: 'Supervise Stage For Candidates',
  registrationForm:
    'Form used to gather candidate information for contest or assessment participation.',
  closeRegistration:
    'The deadline after which new candidate applications will no longer be accepted.',
  contestStartTime:
    'This is the planned start time for the contest. The first stage will not start automatically and must be triggered manually.',
  registrationFormUrl: 'Copy Application Form URL',

  // *************************ASSESSMENT LEVEL TOOLTIPS ***************************

  // Candidate Status Tooltips
  EMAIL_NOT_VERIFIED: `Candidate has been invited but hasn't verified their email yet.`,
  EMAIL_VERIFIED: 'Candidate has successfully verified their email.',
  SYSTEM_CHECK_PENDING:
    'Email verified, but system check (required before assessment) is still pending.',
  SYSTEM_CHECK_SKIPPED:
    'Candidate faced issues with the system check and it was skipped.',
  SYSTEM_CHECK_PASSED: 'Candidate has completed the required system check.',
  SYSTEM_CHECK_FAILED: `Candidate's system did not meet the minimum requirements for the assessment.`,
  SCHEDULED: `Candidate's assessment round has been scheduled.`,
  NOT_STARTED: `Stage is enabled, but the candidate hasn't started yet. You can reject them.`,
  IN_PROGRESS:
    'Candidate is currently attempting the stage. You can still reject them.',
  SUBMITTED_PENDING_REVIEW:
    'Stage is complete, but score input is pending from your side.',
  SUBMITTED_EVALUATING:
    'Candidate submitted their solution. Evaluation is in progress.',
  SUBMITTED_NOT_CONCLUDED:
    'Candidate has finished all stages. Final score and feedback are still pending.',
  FINISHED: `Candidate's submission is evaluated. You can proceed to the next stage or reject.`,
  REJECTED_NOT_CONCLUDED: `Candidate was absent or didn't submit any solution. Rejected but not finalized.`,
  FINISHED_CONCLUDED:
    'Candidate successfully completed all stages and received final feedback.',
  REJECTED_CONCLUDED:
    'Candidate was rejected or disqualified and the rejection has been finalized with feedback.',
  UNKNOWN: 'Contact support!',
  NO_SHOW:
    'Candidate missed the start deadline. Stage is locked. Extend the deadline to allow progress.',
  startByWindow: `When candidate becomes eligible to appear for this stage, he can attempt this stage at his own convenience. The candidate must start this stage after he becomes eligible to appear for this stage. i.e. if this stage is the first stage of this assessment, he/she must start this stage before this time after this stage is scheduled. If the stage is any other stage other than first stage, candidate can start this stage after completion of the previous stage.`,
  deadlineToStartStage:
    'When candidate becomes eligible to appear for this stage, he can attempt this stage at his own convenience. When this checkbox is unchecked, the candidate does not have a specific deadline to start this stage. Once he/she starts the stage, the Duration configured for this stage is still applicable.',

  // *************************DATABASE LEVEL TOOLTIPS**************************
  databaseName:
    'Unique name for the database, used for reference in challenges.',
  databaseDescription:
    'Brief details about the database, including its purpose and structure.',
  databaseType: 'Select the database type (e.g., PostgreSQL).',
  databaseRuntime:
    'Specify the execution environment or configuration for the database instance.',
  sqlScript:
    'SQL script to initialize the database with tables, schemas, and test data.',

  // ***************************WORKSPACES LEVEL TOOLTIPS**********************
  superAdmin:
    'Checking this box grants the user Super Admin access, making them an admin in all workspaces.',
  // ***************************AI INTERVIEW STAGE TOOLTIPS**********************
  topicGroups:
    'A Topic Group contains multiple topic options and their subtopics. During the interview, the AI will ask questions based on the topic option selected by the candidate',
  JDSummary:
    'Write a brief, compelling overview of the role. Include the team the candidate will join, major focus areas, required skills, and how the role contributes to larger company or project goals.',

  // ***************************ACTION ICON'S AND COMMON TOOLTIPS******************************
  addDuration: 'Add Duration',
  addOption: 'Add Option',
  addScore: 'Add Score',
  addScoreAndFeedback: 'Add Score & Feedback',
  allTestCaseFailed: 'All Testcases Failed',
  allTestCasePassed: 'All Testcases Passed',
  attemptDetails: 'Attempt Details',
  audioEnabled: 'Audio Enabled',
  audioNotEnabled: 'Audio Not Enabled',
  audioSettings: 'Audio Settings',
  cancelInivitation: 'Cancel Invitation',
  candidateDetails: 'Candidate Details',
  candidateInformation: 'Candidate Information',
  registrationInformation: 'Application Information',
  preInvite: 'Pre-Invite Candidate',
  inviteCandidate: 'Invite Candidate',
  forceInvite: 'Force Invite Candidate',
  chatWithCandidate: 'Chat With Candidate',
  dependencyChange: ' Dependency Change Detected',
  codeCopyPasted: 'Code Copy Pasted',
  noFaceDetected: 'No Face Detected',
  tabSwitch: 'Tab Switch Detected',
  configureMediaSharing: 'Configure Media Sharing',
  conclude: 'Conclude',
  copy: 'Copy',
  copyAPIKey: 'Copy API Key',
  copyToClipboard: 'Copy to Clipboard',
  delete: 'Delete',
  deleteOption: 'Delete Option',
  disqualifyCandidate: 'Disqualify Candidate',
  edit: 'Edit',
  editAccess: 'Edit Access',
  email: 'Email',
  emailSubject: `Subject line that appears in the recipient's inbox. You can also insert variables by typing {{ — a list of available placeholders will appear. For example, {{candidate.name}} becomes Gaurav Sharma when the email is sent.`,
  emailHeading: `Main heading of the email, typically displayed in a larger font size. You can also insert variables by typing {{ — a list of available placeholders will appear. For example, {{candidate.name}} becomes Gaurav Sharma when the email is sent.`,
  emailBody: `This is the main content of the email. You can insert variables like {{candidate.name}}, which will automatically be replaced with real values — for example, {{candidate.name}} becomes Gaurav Sharma when the email is sent.`,
  instructionsBody: `This is the instructions content of the form. You can insert variables like {{contest.name}}, which will automatically be replaced with real values — for example, {{contest.name}} becomes Campus Hiring 2k25 when the candidate opens the application form.`,
  enableOrScheduleStage: 'Enable or Schedule Stage',
  enableFirstStage: 'Enable first stage to start contest',
  evaluate: 'View Playback',
  evaluateCandidateRecording: 'Evaluate Candidate Recording',
  evaluateScript: `Define the evaluation script to validate candidates' results. This script will be used to compare their output and determine if they pass the challenge.`,
  exit: 'Exit',
  expand: 'Expand',
  failed: 'Failed',
  handRaised: 'Hand Raised',
  ipAddressChange: 'IP Address Change',
  inviteCandidates: 'Invite Candidate',
  leaveInterview: 'Leave Interview',
  leavePlacementTalk: 'Leave Placement Talk',
  leaveSupervision: 'Leave Supervision',
  lowerHand: 'Lower Hand',
  minimiseScreen: 'Minimise Screen Recording',
  minimiseWebcam: 'Minimise Webcam Recording',
  more: 'More',
  moreActions: 'More Actions',
  moveDown: 'Move Down',
  moveToNextStage: 'Move To Next Stage',
  moveUp: 'Move Up',
  moveToTop: 'Move to Top',
  moveToBottom: 'Move to Bottom',
  muteAudio: 'Mute Audio',
  muteCandidate: 'Mute Candidate',
  name: 'Name',
  options: 'Options',
  passed: 'Passed',
  partialTestCasePassed: 'Partial Testcases Passed',
  phoneNumber: 'Phone Number',
  pin: 'Pin',
  profile: 'Select profile picture',
  progressAcrossCourses: 'Progress Across Courses',
  raiseHand: 'Raise Hand',
  reEnableStage: 'Re-enable Stage',
  viewRemarks: 'View Remarks',
  addRemarks: 'Add Remarks',
  refresh: 'Refresh',
  refreshCandidateStream: 'Refresh Candidate Stream',
  refreshList: 'Refresh List',
  rejectAndConclude: 'Reject & Conclude',
  removeFromSupervision: 'Remove From Supervision',
  removeUser: 'Remove User',
  resendInvite: 'Resend Invite',
  reviewSuspiciousActivity: 'Review Suspicious Activity',
  setting: 'Setting',
  showInDescription: 'Show in description',
  skipSystemCheck: 'Skip System Checks',
  reenableAttempt: 'Re-Enable candidate attempt',
  status: 'Status',
  stageEnablingFailed:
    'Stage enabling failed due to credit insufficiency. Click to retry',
  submitAttempt: 'Submit Attempt',
  testcaseFailed: 'Testcases Failed',
  testcasePassed: 'Testcases Passed',
  totalScoreMustbe100: 'Total score must be 100',
  unPin: 'Unpin',
  unMuteAudio: 'Unmute Audio',
  unmuteCandidate: 'Unmute Candidate',
  hideUserPanel: 'Hide User Panel',
  changeLayout: 'Change Layout',
  showUserPanel: 'Show User Panel',
  view: 'View',
  viewDetails: 'View Details',
  viewAttemptDetails: 'View Attempt Details',
  viewFeedback: 'View Feedback',
  viewLeaderboard: 'View Leaderboard',
  viewSolution: 'View Solution',
  viewSolutionCode: 'View Solution Code',
  viewSolutionDetails: 'View Solution Details',
  viewSummary: 'View Summary',
  viewUser: 'View Users',
  webcamEnalbed: 'Webcam Enalbed',
  webcamNotEnabled: 'Webcam Not Enabled',
  estimationMark:
    'This is an estimation based on the number of candidates eligible for the stage',
  downloadResume: 'Download Resume',
  showWebCam: 'Show Webcam',
  hideWebCam: 'Hide Webcam',
  viewCandidateDetails: 'View Candidate Details',
  pinStream: 'Pin Stream',
  unPinStream: 'Unpin Stream',
  expandCandidateStream: 'Expand candidate stream',
  warnCandidate: 'Warn Candidate',
  screenShared: 'Screen Shared',
  screenNotShared: 'Screen Not Shared',
  automateSupervisionTooltip:
    'Add candidate email addresses for automate supervision',
  tryItOut: 'Try it out',
  startByWindowIcon: 'Update Start-by Deadline',
  approveUser: 'Approve User',
  rejectUser: 'Reject User',

  // ***************************Job Openings TOOLTIPS******************************
  JobTitle:
    'Enter a clear and descriptive job title (e.g., Frontend Developer, Marketing Manager). This helps candidates identify the role easily.',
  aboutCompany:
    'Write a brief overview of your company — include mission, culture, and what makes your company unique.',
  jobDescription:
    'Provide a detailed description of the job role, responsibilities, required skills, and qualifications. Be clear about what you expect from candidates.',
  rolesAndResponsibilities:
    'List key duties the candidate will perform.(e.g., Develop, Manage, Coordinate).',
  keySkills:
    'List essential technical and soft skills required for this role (e.g., JavaScript, Communication). Press Enter after each Core Skill.',
  qualifications:
    'Add required educational qualifications (e.g., B.Tech, MBA) or certifications. Press Enter after each qualification.',
  certifications:
    'List relevant professional certifications required or preferred for this role (e.g., AWS Certified Developer, PMP, Google Analytics). Press Enter after each certification.',
  goodToHave:
    'List additional skills or experiences that are beneficial but not mandatory (e.g., Leadership, Team collaboration, Critical thinking). Press Enter after each skill.',
  experienceMin:
    'Specify the minimum years of experience required for this role (e.g., 2 years, 5 years).',
  experienceMax:
    'Specify the maximum years of experience suitable for this role (e.g., 5 years, 10 years).',
  jobType:
    'Select or add job type (e.g., Full-Time, Part-Time, Internship). Press Enter to add a new type',
  department:
    'Select or add department (e.g., Engineering, Marketing, HR). Press Enter to add a new department.',
  locations:
    'Select or add job location (e.g., New York, Remote, On-site). Press Enter to add a new location.',
  salary:
    'Enter the salary range or expected CTC for the position.(e.g., 5LPA, 10LPA, 5LPA-10LPA).',
  numberOfPositions:
    'Specify the number of openings available for this role (e.g., 1, 3, 5).',
  JDPrompt:
    'Provide a detailed prompt to auto-generate the job opening. Include the job title, level, and department. Mention required and preferred skills, experience requirements, and key responsibilities. You can also add brief company details for more accurate results.',
  autoGenerateAiScore:
    'Generates the AI Scoring automatically as soon as the candidate submits the solution.',
  generateLink: 'Click to generate the shareable attempt details preview link.',
  copySharableLink: 'Click to copy the shareable attempt details preview link.',
  score:
    'Score out of 100 based on the number of test cases passed in the candidate’s submission (includes Input/Output, Unit, or API tests).',
  aiScoreColumnTooltip:
    'AI Score is automatically generated by our AI evaluation system based on code quality, performance, and correctness.',
  showDetails:
    'When this option is selected, basic candidate information (name, email, phone, and photo) will be hidden/masked in the shared link.',
  showResume:
    'When this option is selected, the candidate’s resume or CV will not be accessible in the shared link.',
  showVideo:
    'When this option is selected, candidate’s webcam session and screen recording will not be accessible in the shared link.',
  resumeParsingScore: 'Score generated based by the profile screening  stage.',
  invalidResume: 'The uploaded file is not a resume.',
  scoreGenerationFailed:
    'Something went wrong while generating the score. Please try generating the score again.',
  criteriaFailed:
    'One or more criteria for the application form failed for the candidate.'
}
